import { selectToken } from '@/store/authentication/authentication.selector'
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { apiSettings } from '@common/constants'

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Only attach the access token to OUR Provision API — never leak it to other origins (the ecommerce API,
    // the Identity discovery/userinfo endpoints, or any third-party URL). The token is `provision_api`-scoped
    // and meaningless (and unsafe) elsewhere. Match on the API ROOT (base + version), not just the base:
    // cloud uses a same-origin empty base, so `startsWith('')` would (wrongly) match every request — whereas
    // `/api/v1` matches our relative API calls but not the absolute Identity URLs.
    const apiRoot = `${apiSettings.baseApiUrl}/${apiSettings.baseApiVersion}`
    if (!request.url.startsWith(apiRoot)) {
      return next.handle(request)
    }

    // Read the token once (take(1) — no leaked per-request subscription) and attach it synchronously.
    return this.store.select(selectToken).pipe(
      take(1),
      switchMap((token) => {
        const authorized =
          token && token.length > 0
            ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
            : request
        return next.handle(authorized)
      })
    )
  }
}
